import { render, staticRenderFns } from "./CompanyDrawerContactTab.vue?vue&type=template&id=f9663eba&"
import script from "./CompanyDrawerContactTab.vue?vue&type=script&lang=ts&"
export * from "./CompanyDrawerContactTab.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDrawerContactTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports